module.exports = __webpack_public_path__ + "media/images/weather/61_night-9d115c531132a87290ce851e948f0a3c.png";